<script setup>
import { router, usePage } from '@inertiajs/vue3';
import { trans } from 'laravel-vue-i18n';

const $page = usePage();

const getLocalizedPath = (newLocale) => {
    // If switching to Romanian, remove locale from path
    if (newLocale === 'ro') {
        const segments = window.location.pathname.split('/');
        if (segments[1] === 'en') {
            segments.splice(1, 1);
        }
        return segments.join('/') || '/';
    }

    // If switching to English, add /en
    const segments = window.location.pathname.split('/');
    if (segments[1] !== 'en') {
        segments.splice(1, 0, 'en');
    }
    return segments.join('/');
};

const switchLocale = (locale) => {
    // Get current route
    const currentRoute = window.location.pathname;

    // Check if we're on a public page (doesn't start with /dashboard or other authenticated routes)
    const isPublicPage = !currentRoute.match(/^\/(dashboard|amprenta-de-carbon|profil-companie|tasks|reports|companies|documentatie-api|lca|ecommerce|utilities|hr|inventory|fleet|suppliers|sales|recycling|embed|events)/);

    if (isPublicPage) {
        // For public pages, update the URL with the locale
        const newPath = getLocalizedPath(locale);
        window.location.href = newPath;
    } else {
        // For authenticated pages, just set the locale without changing URL
        document.documentElement.lang = locale;
        document.cookie = `locale=${locale};path=/;`;
        window.location.reload();
    }
};
</script>

<template>
    <div class="flex items-center space-x-2">
        <button @click="switchLocale('en')" class="w-8 h-8  overflow-hidden hover:opacity-75 transition-opacity">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 32 32">
                <rect x="1" y="4" width="30" height="24" rx="4" ry="4" fill="#fff"></rect>
                <path fill="#012169" d="M1 4h30v24H1z"></path>
                <path fill="#fff" d="M3.785 4 16 13.17 28.215 4H31v2.58L19.333 16l11.667 9.42V28h-2.785L16 18.83 3.785 28H1v-2.58L12.667 16 1 6.58V4h2.785Z"></path>
                <path fill="#c8102e" d="m1 4 10.667 8H9.333L1 5.05V4Zm30 0-10.667 8h2.334L31 5.05V4ZM1 28l10.667-8H9.333L1 26.95V28Zm30 0-10.667-8h2.334L31 26.95V28Z"></path>
                <path fill="#fff" d="M12.667 4v8H1v8h11.667v8h6.666v-8H31v-8H19.333V4h-6.666Z"></path>
                <path fill="#c8102e" d="M14.667 4v10H1v4h13.667v10h2.666V18H31v-4H17.333V4h-2.666Z"></path>
            </svg>
        </button>
        <button @click="switchLocale('ro')" class="w-8 h-8  overflow-hidden hover:opacity-75 transition-opacity">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 32 32">
                <rect x="1" y="4" width="30" height="24" rx="4" ry="4" fill="#fff"></rect>
                <path fill="#002b7f" d="M1 4h10v24H1z"></path>
                <path fill="#fcd116" d="M11 4h10v24H11z"></path>
                <path fill="#ce1126" d="M21 4h10v24H21z"></path>
            </svg>
        </button>
    </div>
</template>
